import { render } from "./ConfirmationRdv.vue?vue&type=template&id=5785981c&scoped=true"
import script from "./ConfirmationRdv.vue?vue&type=script&lang=js"
export * from "./ConfirmationRdv.vue?vue&type=script&lang=js"

import "./ConfirmationRdv.vue?vue&type=style&index=0&id=5785981c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5785981c"

export default script